import React, { MouseEvent } from 'react';
import { ClickableParams } from './types';

const Button = ({ id, cssName, onClick, disabled, noShadow, children }: ClickableParams): JSX.Element => {
    const classes = ['component-button'];
    if (cssName) classes.push(cssName);
    if (noShadow) classes.push('no-shadow');
    const className = classes.join(' ');

    function handleClick(e: MouseEvent): void {
        e.preventDefault();
        e.stopPropagation();
        onClick();
    }

    return (
        <button
            id={id}
            className={className}
            onClick={handleClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

export default Button;
